var limits = {
    data: () => ({
        min_value: {
            "temperature": -30,
            "pet": -30,
            "mrt": -30,
            "utci": -30,
            "pressure": 980,
            "humidity": 0,
            "wind": 0,
            "cloud":0,
            "prec": 0
        },
        max_value: {
            "temperature": 30,
            "pet": 30,
            "mrt": 30,
            "utci": 30,
            "pressure": 1040,
            "humidity": 100,
            "wind": 10,
            "cloud":10,
            "prec": 20
        },
                min_value_norm: {
            "temperature": -10,
            "pet": -10,
            "mrt": -10,
            "utci": -10,
            "pressure": -25,
            "humidity": -50,
            "wind": -10,
            "cloud":-10,
            "prec": -10,
            "nh3": -1,
            "susp_sol": -1,
            "pm10": -1,
            "pm25": -1,
            "no2": -1,
            "so2": -1,
            "o3": -1,
            "co": -1,
            "ch4": -1,
            "h2s": -1,
            "no": -1,
            "c6h6": -1,
            "c10h8": -1,
            "c8h8": -1,
            "c7h8": -1,
            "c6h5oh": -1,
            "ch2o": -1
        },
        max_value_norm: {
            "temperature": 10,
            "pet": 10,
            "mrt": 10,
            "utci": 10,
            "pressure": 25,
            "humidity": 50,
            "wind": 10,
            "cloud": 10,
            "prec": 10,
            "nh3": 1,
            "susp_sol": 1,
            "pm10": 1,
            "pm25": 1,
            "no2": 1,
            "so2": 1,
            "o3": 1,
            "co": 1,
            "ch4": 1,
            "h2s": 1,
            "no": 1,
            "c6h6": 1,
            "c10h8": 1,
            "c8h8": 1,
            "c7h8": 1,
            "c6h5oh": 1,
            "ch2o": 1
        },
        center_value: {
            "temperature": 0,
            "pet": 0,
            "mrt": 0,
            "utci": 0,
            "pressure": 1010,
            "humidity": 70,
            "wind": 2.3,
            "cloud": 7.8,
            "prec": 0
        },
        step_value: {
            "temperature": 1,
            "pet": 1,
            "mrt": 1,
            "utci": 1,
            "pressure": 2.5,
            "humidity":5,
            "wind": 1,
            "cloud":1,
            "prec": 1
        }
    })
}

export default limits;